/**
 * Client wrapper for signup CAPTCHA verification callable.
 */

import { getFunctions, httpsCallable, type FunctionsError } from 'firebase/functions';
import { getClientApp } from '@canvas/firebase-config/client';

const FUNCTIONS_REGION = 'asia-southeast1';

export async function verifySignupCaptcha(token: string): Promise<void> {
  if (!token.trim()) {
    throw new Error('Complete the CAPTCHA before creating an account.');
  }

  const functions = getFunctions(getClientApp(), FUNCTIONS_REGION);
  const callable = httpsCallable<{ token: string }, { ok: boolean }>(
    functions,
    'verifySignupCaptcha'
  );

  try {
    const result = await callable({ token });
    if (!result.data?.ok) {
      throw new Error('CAPTCHA verification failed. Try again.');
    }
  } catch (err) {
    const fe = err as FunctionsError;
    if (fe?.code === 'functions/permission-denied') {
      throw new Error('CAPTCHA verification failed. Try again.');
    }
    if (fe?.code === 'functions/failed-precondition') {
      throw new Error(
        fe.message ||
          'CAPTCHA is not configured on the server. Set RECAPTCHA_SECRET_KEY for Cloud Functions.'
      );
    }
    if (fe?.code === 'functions/unavailable' || fe?.code === 'functions/not-found') {
      throw new Error(
        'CAPTCHA service is unavailable. Deploy verifySignupCaptcha or check your connection.'
      );
    }
    if (err instanceof Error) throw err;
    throw new Error('CAPTCHA verification failed.');
  }
}
